export default __webpack_public_path__ + "static/background-min-c3150242d5d879c088878903a5a7a0ed.webp";